import {
  Box,
  Button,
  Container,
  List,
  ListItem,
  ListItemText,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
  Skeleton,
  CircularProgress,
} from "@mui/material";
import axios from "axios";
import React, { useState, useEffect } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  menuItemsState,
  selectedMenuItemsState,
  nameState,
  phoneState,
  emailState,
  orderIdState,
} from "../atoms";
import { baseUrl } from "../constants";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";

function Cart() {
  const { hotelId, shopId, tableId, tableNumber } = useParams();
  const navigate = useNavigate();
  let customerName = useRecoilValue(nameState);
  let customerEmail = useRecoilValue(emailState);
  let customerPhone = useRecoilValue(phoneState);

  // Fetch data from Recoil state
  const menuItems = useRecoilValue(menuItemsState);
  const selectedMenuItems = useRecoilValue(selectedMenuItemsState);
  const [pricingData, setpricingData] = useState(null);
  const [orderId, setOrderId] = useRecoilState(orderIdState);
  const newOrderId = useRecoilValue(orderIdState);
  const [odOrderData, setodOrderData] = useState([]);
  const [invoiceNumber, setinvoiceNumber] = useState(null);
  const [loader, setloader] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const productsWithValues = Object.values(selectedMenuItems).flatMap(
    (category) =>
      Object.entries(category)
        .filter(([productId, value]) => value > 0)
        .map(([productId, value]) => ({ productId, value }))
  );

  const [taxCategories, setAllTaxCategories] = useState([]);
  useEffect(() => {
    async function getAllTaxes() {
      try {
        const taxes = await axios
          .get(
            `${baseUrl}/api/v2/tax/getAllTaxCategories/?hotel_id=${hotelId}&hotelId=${hotelId}`
          )
          .then((resp) => resp.data);

        const groupTaxes = await axios
          .get(
            `${baseUrl}/api/v2/grouptax/getAllGroupTaxCategories/?hotel_id=${hotelId}&hotelId=${hotelId}`
          )
          .then((resp) => resp.data);

        const formattedGrpTaxes = groupTaxes.map((grpTax) => ({
          id: grpTax?.id,
          name: grpTax?.name,
          province: "India",
          percentage: (grpTax?.tax_components || [])?.reduce((acc, curr) => {
            return acc + (curr?.tax_percentage || 0);
          }, 0),
          is_group_tax: "true",
        }));

        const allTaxes = [...taxes, ...formattedGrpTaxes];
        setAllTaxCategories(allTaxes);
      } catch {
        console.error("Error in fetching the taxes. Contact the support team.");
      }
    }

    getAllTaxes();
  }, []);

  // Getting the tax percentage based on the tax id
  const getTaxPerc = (taxId) => {
    const taxPercentage = taxCategories?.filter(
      (taxCategory) => String(taxCategory.id) === String(taxId)
    );
    return Number(
      taxPercentage[0] !== undefined ? taxPercentage[0]?.percentage : 0
    );
  };

  useEffect(() => {
    if (productsWithValues.length > 0) {
      calculatePrices();
    } else {
      navigate(`/cat/${hotelId}/${shopId}/${tableId}/${tableNumber}`);
    }
  }, [JSON.stringify(productsWithValues)]);

  const calculatePrices = () => {
    let itemData = [];
    productsWithValues.map((item) => {
      let obj = {
        orderDetailId: -1,
        productId: item.productId,
        quantity: item.value,
        taxCategoryId: menuItems.filter(
          (res) => Number(res.id) === Number(item.productId)
        )[0].product_tax_id,
        discountId: -1,
        kotId: 0,
      };
      itemData.push(obj);
    });

    const payload = {
      items: itemData,
      isOrderLevelDiscountApplied: "NO",
      orderLevelDiscountType: "percent",
      orderLevelDiscountValue: 0,
      isServiceChargeApplied: "NO",
    };

    axios
      .post(
        `${baseUrl}/core/api/v1/pos-pricing/get-detailed-summery?shopId=${shopId}&hotel_id=${hotelId}&hotelId=${hotelId}`,
        payload
      )
      .then((res) => setpricingData(res.data));
  };

  const getProductName = (id) => {
    return menuItems.filter((res) => Number(res.id) === Number(id))[0]
      .product_name;
  };

  const getProductPrice = (id) => {
    return menuItems.filter((res) => Number(res.id) === Number(id))[0]
      .product_price;
  };

  const addToCart = () => {
    setloader(true);
    let payload;
    if (newOrderId === undefined || newOrderId === null || newOrderId === "") {
      console.log("S1");
      let itemData = [];
      productsWithValues.map((item) => {
        let obj = {
          orderDetailId: -1,
          productId: item.productId,
          quantity: item.value,
          taxCategoryId: menuItems.filter(
            (res) => Number(res.id) === Number(item.productId)
          )[0].product_tax_id,
          discountId: -1,
          kotId: 0,
        };
        itemData.push(obj);
      });

      let orderData = [];
      productsWithValues.map((item) => {
        let selectedItem = menuItems.filter(
          (res) => Number(res.id) === Number(item.productId)
        )[0];
        let obj = {
          id: -1,
          shop_id: shopId,
          hotel_id: hotelId,
          order_id: -1,
          product_id: selectedItem.id,
          product_qty: item.value,
          product_name: selectedItem.product_name,
          custom_product_name: selectedItem.product_name,
          item_type: selectedItem.product_type,
          product_price: selectedItem.product_price * item.value,
          product_tax_perc: getTaxPerc(selectedItem.product_tax_id),
          tax_id: selectedItem.product_tax_id,
          product_discount: 0,
          special_requests: "",
          kot_id: "",
          applied_discount_id: 0,
          kot_status: "REGULAR",
        };
        orderData.push(obj);
      });

      payload = {
        id: -1,
        hotel_id: hotelId,
        shop_id: shopId,
        cust_email: customerEmail,
        cust_name: customerName,
        cust_phone: customerPhone,
        cust_gst_no: "",
        booking_id: "",
        reservation_id: "",
        room_id: null,
        order_amount: pricingData.totalOrderAmount,
        order_date: moment().format("YYYY-MM-DD HH:mm:ss"),
        last_modified_date: moment().format("YYYY-MM-DD HH:mm:ss"),
        order_table_id: tableId,
        order_status: "RUNNING",
        tax_percentage: pricingData.totalTaxAmount,
        order_desc: "",
        order_staff_id: 0,
        order_metadata: "",
        order_user_source: "RESTAURANT",
        total_order_discount: 0,
        custom_discount: 0,
        custom_discount_type: "percent",
        custom_discount_value: 0,
        complimentary_order: "NO",
        complimentary_order_reason: "",
        order_details: orderData,
        random_order_id: -1,
        no_of_persons: 1,
        order_sequence_start: 1,
        invoice_no: -1,
        service_charge: 0,
        apply_service_charge_bydefault: "NO",
        round_off_amount: 0.0,
        pos_pricing_request: {
          items: itemData,
          isOrderLevelDiscountApplied: "NO",
          orderLevelDiscountType: "percent",
          orderLevelDiscountValue: 0,
          isServiceChargeApplied: "NO",
        },
        is_qr_order: "YES",
      };
    } else if (
      odOrderData.filter((item) => item.kot_id !== "" && item.kot_id !== null)
        .length > 0
    ) {
      console.log("S2");
      // Retain existing order details and add new items
      let itemData = [];
      let orderData = [...odOrderData]; // Keep existing order details

      productsWithValues.map((item) => {
        const selectedItem = menuItems.find(
          (res) => Number(res.id) === Number(item.productId)
        );
        let productTotalPrice = getProductPrice(item.productId) * item.value;

        let newItem = {
          id: -1, // New order detail ID
          shop_id: shopId,
          hotel_id: hotelId,
          order_id: newOrderId, // Existing order ID
          product_id: item.productId,
          product_qty: item.value,
          product_name: selectedItem.product_name,
          custom_product_name: selectedItem.product_name,
          item_type: selectedItem.product_type,
          product_price: productTotalPrice,
          product_tax_perc: getTaxPerc(selectedItem.product_tax_id),
          tax_id: selectedItem.product_tax_id,
          product_discount: 0,
          special_requests: "",
          kot_id: "",
          applied_discount_id: 0,
          kot_status: "REGULAR",
        };

        orderData.push(newItem); // Add the new item to the existing order details

        // itemData.push({
        //   orderDetailId: -1, // New order detail ID for the item
        //   productId: item.productId,
        //   quantity: item.value,
        //   taxCategoryId: selectedItem.product_tax_id,
        //   discountId: -1,
        //   kotId: 0,
        // });
      });

      // Final step: Ensure all items in orderData have a corresponding itemData entry
      orderData.forEach((orderItem) => {
        itemData.push({
          orderDetailId: orderItem.id,
          productId: orderItem.product_id,
          quantity: orderItem.product_qty,
          taxCategoryId: orderItem.tax_id,
          discountId: -1,
          kotId: orderItem.kot_id === "" ? 0 : orderItem.kot_id,
        });
      });

      payload = {
        id: newOrderId,
        hotel_id: hotelId,
        shop_id: shopId,
        cust_email: customerEmail,
        cust_name: customerName,
        cust_phone: customerPhone,
        cust_gst_no: "",
        booking_id: "",
        reservation_id: "",
        room_id: null,
        order_amount: pricingData.totalOrderAmount,
        order_date: moment().format("YYYY-MM-DD HH:mm:ss"),
        last_modified_date: moment().format("YYYY-MM-DD HH:mm:ss"),
        order_table_id: tableId,
        order_status: "RUNNING",
        tax_percentage: pricingData.totalTaxAmount,
        order_desc: "",
        order_staff_id: 0,
        order_metadata: "",
        order_user_source: "RESTAURANT",
        total_order_discount: 0,
        custom_discount: 0,
        custom_discount_type: "percent",
        custom_discount_value: 0,
        complimentary_order: "NO",
        complimentary_order_reason: "",
        order_details: orderData, // Combined existing and new order details
        random_order_id: "-1",
        no_of_persons: 1,
        order_sequence_start: 1,
        invoice_no: invoiceNumber,
        service_charge: 0,
        apply_service_charge_bydefault: "NO",
        round_off_amount: 0.0,
        pos_pricing_request: {
          items: itemData,
          isOrderLevelDiscountApplied: "NO",
          orderLevelDiscountType: "percent",
          orderLevelDiscountValue: 0,
          isServiceChargeApplied: "NO",
        },
        is_qr_order: "YES",
      };
    } else {
      console.log("S3");
      let itemData = [];
      let orderData = [...odOrderData]; // Keep the existing order details as it is
      let totalOrderAmount = pricingData.totalOrderAmount; // Initialize with existing total

      productsWithValues.map((item) => {
        const existingOrderItem = odOrderData.find(
          (orderItem) => Number(orderItem.product_id) === Number(item.productId)
        );

        let productPrice = getProductPrice(item.productId);
        let productTotalPrice = productPrice * item.value;

        if (existingOrderItem) {
          // Update the existing item's quantity and price
          existingOrderItem.product_qty += item.value;
          existingOrderItem.product_price += productTotalPrice;
          existingOrderItem.order_id = newOrderId;

          itemData.push({
            orderDetailId: existingOrderItem.id,
            productId: existingOrderItem.product_id,
            quantity: existingOrderItem.product_qty,
            taxCategoryId: existingOrderItem.tax_id,
            discountId: -1,
            kotId: 0,
          });

          totalOrderAmount += productTotalPrice;
        } else {
          // Add a new item
          let newItem = {
            id: -1,
            shop_id: shopId,
            hotel_id: hotelId,
            order_id: newOrderId,
            product_id: item.productId,
            product_qty: item.value,
            product_name: getProductName(item.productId),
            custom_product_name: getProductName(item.productId),
            item_type: menuItems.find(
              (res) => Number(res.id) === Number(item.productId)
            )?.product_type,
            product_price: productTotalPrice,
            product_tax_perc: getTaxPerc(
              menuItems.find((res) => Number(res.id) === Number(item.productId))
                ?.product_tax_id
            ),
            tax_id: menuItems.find(
              (res) => Number(res.id) === Number(item.productId)
            )?.product_tax_id,
            product_discount: 0,
            special_requests: "",
            kot_id: "",
            applied_discount_id: 0,
            kot_status: "REGULAR",
          };

          orderData.push(newItem); // Add the new product to orderData
          itemData.push({
            orderDetailId: -1,
            productId: newItem.product_id,
            quantity: newItem.product_qty,
            taxCategoryId: newItem.tax_id,
            discountId: -1,
            kotId: 0,
          });

          totalOrderAmount += productTotalPrice;
        }
      });

      // Final step: Ensure all items in orderData have a corresponding itemData entry
      orderData.forEach((orderItem) => {
        if (!itemData.some((item) => item.productId === orderItem.product_id)) {
          itemData.push({
            orderDetailId: orderItem.id,
            productId: orderItem.product_id,
            quantity: orderItem.product_qty,
            taxCategoryId: orderItem.tax_id,
            discountId: -1,
            kotId: 0,
          });
        }
      });

      payload = {
        id: newOrderId,
        hotel_id: hotelId,
        shop_id: shopId,
        cust_email: customerEmail,
        cust_name: customerName,
        cust_phone: customerPhone,
        cust_gst_no: "",
        booking_id: "",
        reservation_id: "",
        room_id: null,
        order_amount: totalOrderAmount,
        order_date: moment().format("YYYY-MM-DD HH:mm:ss"),
        last_modified_date: moment().format("YYYY-MM-DD HH:mm:ss"),
        order_table_id: tableId,
        order_status: "RUNNING",
        tax_percentage: pricingData.totalTaxAmount,
        order_desc: "",
        order_staff_id: 0,
        order_metadata: "",
        order_user_source: "RESTAURANT",
        total_order_discount: 0,
        custom_discount: 0,
        custom_discount_type: "percent",
        custom_discount_value: 0,
        complimentary_order: "NO",
        complimentary_order_reason: "",
        order_details: orderData, // Include the updated order details
        random_order_id: "-1",
        no_of_persons: 1,
        order_sequence_start: 1,
        invoice_no: invoiceNumber,
        service_charge: 0,
        apply_service_charge_bydefault: "NO",
        round_off_amount: 0.0,
        pos_pricing_request: {
          items: itemData, // Include the updated item data
          isOrderLevelDiscountApplied: "NO",
          orderLevelDiscountType: "percent",
          orderLevelDiscountValue: 0,
          isServiceChargeApplied: "NO",
        },
        is_qr_order: "YES",
      };
    }

    finalPrices(payload, payload.pos_pricing_request.items);
  };

  const saveOrder = (payload, prices) => {
    payload.tax_percentage = prices.totalTaxAmount;
    payload.order_amount = prices.totalOrderAmount;
    payload.round_off_amount = prices.roundOffAmount;

    axios
      .post(
        `${baseUrl}/core/api/v1/orders/create-update?hotel_id=${hotelId}&hotelId=${hotelId}`,
        payload
      )
      .then((res) => {
        setloader(false);
        setOrderId(res.data);
        navigate(`/success/${hotelId}/${shopId}/${tableId}/${tableNumber}`, {
          state: { orderId: res.data },
        });
      })
      .catch((err) => {
        console.error(err);
        setloader(false);
      });
  };

  const getOdForOrder = () => {
    axios
      .get(
        `${baseUrl}/core/api/v1/order-details/get-od-for-order?orderId=${newOrderId}&shopId=${shopId}&hotel_id=${hotelId}&hotelId=${hotelId}`
      )
      .then((res) => setodOrderData(res.data));
  };

  const getRunningOrder = () => {
    axios
      .get(
        `${baseUrl}/core/api/v1/orders/get-running-order?tableId=${tableId}&shopId=${shopId}&hotel_id=${hotelId}&hotelId=${hotelId}`
      )
      .then((res) => setinvoiceNumber(res.data.invoice_no));
  };

  useEffect(() => {
    if (newOrderId !== null && newOrderId !== undefined && newOrderId !== "") {
      getRunningOrder();
    }
  }, [newOrderId]);
  useEffect(() => {
    getOdForOrder();
  }, []);

  const finalPrices = (data, itemData) => {
    const payload = {
      items: itemData,
      isOrderLevelDiscountApplied: "NO",
      orderLevelDiscountType: "percent",
      orderLevelDiscountValue: 0,
      isServiceChargeApplied: "NO",
    };

    axios
      .post(
        `${baseUrl}/core/api/v1/pos-pricing/get-detailed-summery?shopId=${shopId}&hotel_id=${hotelId}&hotelId=${hotelId}`,
        payload
      )
      .then((res) => {
        saveOrder(data, res.data);
      })
      .catch((err) => {
        console.error(err);
        setloader(false);
      });
  };

  return (
    <Container maxWidth="sm">
      <Paper
        elevation={3}
        sx={{
          p: isMobile ? 2 : 4,
          mt: 4,
          width: "100%",
          maxWidth: "100%",
        }}
      >
        <Typography
          variant={isMobile ? "h6" : "h5"}
          gutterBottom
          style={{ color: "gray" }}
        >
          Cart Items
        </Typography>
        <List style={{ overflowY: "scroll", maxHeight: "14rem" }}>
          {productsWithValues.map((item) => (
            <ListItem
              key={item.productId}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <div className="d-flex flex-column w-100">
                {" "}
                <ListItemText primary={getProductName(item.productId)} />
                <ListItemText secondary={`Quantity: ${item.value}`} />
              </div>

              <Box sx={{ display: "flex", alignItems: "center", width: "45%" }}>
                <ListItemText
                  primary={`Rs. ${parseFloat(
                    parseFloat(getProductPrice(item.productId)).toFixed(2) *
                      Number(item.value)
                  ).toFixed(2)}`}
                />
              </Box>
            </ListItem>
          ))}
        </List>
      </Paper>
      <Paper
        elevation={3}
        sx={{
          p: isMobile ? 2 : 4,
          mt: 4,
          width: "100%",
          maxWidth: "100%",
        }}
      >
        <Typography
          variant={isMobile ? "h6" : "h5"}
          gutterBottom
          style={{ color: "gray" }}
        >
          Bill details
        </Typography>
        <List>
          <ListItem sx={{ display: "flex", alignItems: "center" }}>
            <div className="d-flex flex-column w-100">
              <ListItemText primary={"Sub-total"} />
            </div>

            <Box sx={{ display: "flex", alignItems: "center", width: "50%" }}>
              {pricingData ? (
                <ListItemText
                  primary={`Rs. ${parseFloat(pricingData.subTotal).toFixed(2)}`}
                />
              ) : (
                <Skeleton variant="text" width={100} />
              )}
            </Box>
          </ListItem>
          <ListItem sx={{ display: "flex", alignItems: "center" }}>
            <div className="d-flex flex-column w-100">
              <ListItemText primary={"Taxes"} />
            </div>
            <Box sx={{ display: "flex", alignItems: "center", width: "50%" }}>
              {pricingData ? (
                <ListItemText
                  primary={`Rs. ${parseFloat(
                    pricingData.totalTaxAmount
                  ).toFixed(2)}`}
                />
              ) : (
                <Skeleton variant="text" width={100} />
              )}
            </Box>
          </ListItem>
          <ListItem sx={{ display: "flex", alignItems: "center" }}>
            <div className="d-flex flex-column w-100">
              <ListItemText primary={"Total"} />
            </div>
            <Box sx={{ display: "flex", alignItems: "center", width: "50%" }}>
              {pricingData ? (
                <ListItemText
                  primary={`Rs. ${parseFloat(
                    pricingData.totalOrderAmount
                  ).toFixed(2)}`}
                />
              ) : (
                <Skeleton variant="text" width={100} />
              )}
            </Box>
          </ListItem>
        </List>
      </Paper>
      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          width: "100%",
          bgcolor: "background.paper",
          py: 2,
          borderTop: "1px solid #ddd",
          textAlign: "center",
        }}
      >
        <Button
          variant="custom-button"
          color="primary"
          onClick={addToCart}
          disabled={!pricingData || loader} // Disable the button until pricing data is loaded
        >
          {loader ? (
            <CircularProgress size={15} color="inherit" />
          ) : (
            "Place order"
          )}
        </Button>
      </Box>
    </Container>
  );
}

export default Cart;
